import { render, staticRenderFns } from "./CpdPointsData.vue?vue&type=template&id=43c8e822"
import script from "./CpdPointsData.vue?vue&type=script&lang=js"
export * from "./CpdPointsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports